import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import MyButton from "../../util/MyButton";
import withStyles from "@material-ui/core/styles/withStyles";

// MUI stuff
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Typography from "@material-ui/core/Typography";

import { connect } from "react-redux";
import { deletePost } from "../../redux/actions/dataActions";

const styles = {
  deleteButton: {
    color: "#F00",
  },
};

const DeletePost = (props) => {
  const { classes, postId } = props;

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deletePost = () => {
    props.deletePost(postId);
    setOpen(false);
  };

  return (
    <Fragment>
      <MyButton
        tip="Delete Post"
        onClick={handleOpen}
        btnClassName={classes.deleteButton}
      >
        <DeleteOutline style={{ color: "#FD1D1D" }} />
      </MyButton>
      <Dialog open={open} onClose={handleClose} sm>
        <DialogTitle>
          <Typography variant="h6" style={{fontWeight:"700"}}>Delete Post?</Typography>
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={deletePost} style={{ color: "#F00" }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

DeletePost.protoTypes = {
  deletePost: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  postId: PropTypes.string.isRequired,
};

export default connect(null, { deletePost })(withStyles(styles)(DeletePost));
